import { useModalHandlers } from 'components/modal';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export function useFileNotFoundModal() {
  const history = useHistory();
  const { showModal, hideModal } = useModalHandlers();

  const showFileNotFoundModal = useCallback(() => {
    showModal({
      body: 'The file you are trying to access has been deleted.',
      customHeader: (
        <div
          id="usefilenotfoundmodal-showfilenotfound-text"
          className="px-6 py-4 flex items-center font-roboto text-xl leading-[120%] font-normal text-[#f7a246]"
        >
          File Not Found
        </div>
      ),
      okButtonText: 'GO TO HOMEPAGE',
      isOkOnly: true,
      hideCloseButton: true,
      onOk: () => {
        history.push('/');
        hideModal();
      },
      isModalEscapeable: false,
    });
  }, [history]);

  return showFileNotFoundModal;
}
